import Logo from "./assets/Logo.png";
import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  visualizerIcon: {
    maxWidth: "153px",
    textAlign: "center",
    position: "absolute",
    top: "1rem",
    left: "1rem",
    zIndex: 99,
    borderRadius: "1rem",
    background: "#ffffff6e",
    padding: "0.5rem",
  },
}));

const HeaderLogo = () => {
  const classes = useStyles();

  return (
    <div className={`${classes.visualizerIcon}`}>
      <img
        alt="product visualizer logo"
        src={Logo}
        style={{ height: "50px" }}
      />
    </div>
  );
};

export default HeaderLogo;
